const profilsVIA = [
    "Donneur d'ordre",
    "Créateur - Architecte",
    "Créateur - Designer objet",
    "Créateur - Designer espace",
    "Créateur - Graphiste",
    "Créateur - Scénographe",
    "Créateur - Stratégie de marque",
    "Créateur - Stratégie digitale",
    "Producteur -  Galerie",
    "Producteur - Equipementier / Matériaux",
    "Producteur - Agenceur",
    "Producteur - Artisan d'art",
    "Producteur - Editeur",
    "Producteur - Fabricant",
    "Producteur - Distributeur",
    "Producteur - Autres"
]

const profilsNonVIA = [
    "Presse",
    "Institutionnel",
    "Institutionnel - Ecole",
    "Institutionnel - Consulat / ambassade",
    "Institutionnel - Musée / centre d'art",
    "Institutionnel - Salon / foire",
    "Autres"
]

const categoriesViaListing = [
    {code : "Donneur d'ordre", fr : "Donneur d'ordre", en : "Donneur d'ordre"},
    {code : "Créateur - Architecte", fr : "Créateur - Architecte", en : "Créateur - Architecte"},
    {code : "Créateur - Designer objet", fr : "Créateur - Designer objet", en : "Créateur - Designer objet"},
    {code : "Créateur - Designer espace", fr : "Créateur - Designer espace", en : "Créateur - Designer espace"},
    {code : "Créateur - Graphiste", fr : "Créateur - Graphiste", en : "Créateur - Graphiste"},
    {code : "Créateur - Scénographe", fr : "Créateur - Scénographe", en : "Créateur - Scénographe"},
    {code : "Créateur - Stratégie de marque", fr : "Créateur - Stratégie de marque", en : "Créateur - Stratégie de marque"},
    {code : "Créateur - Stratégie digitale", fr : "Créateur - Stratégie digitale", en : "Créateur - Stratégie digitale"},
    {code : "Producteur -  Galerie", fr : "Producteur -  Galerie", en : "Producteur -  Galerie"},
    {code : "Producteur - Equipementier / Matériaux", fr : "Producteur - Equipementier / Matériaux", en : "Producteur - Equipementier / Matériaux"},
    {code : "Producteur - Agenceur", fr : "Producteur - Agenceur", en : "Producteur - Agenceur"},
    {code : "Producteur - Artisan d'art", fr : "Producteur - Artisan d'art", en : "Producteur - Artisan d'art"},
    {code : "Producteur - Editeur", fr : "Producteur - Editeur", en : "Producteur - Editeur"},
    {code : "Producteur - Fabricant", fr : "Producteur - Fabricant", en : "Producteur - Fabricant"},
    {code : "Producteur - Distributeur", fr : "Producteur - Distributeur", en : "Producteur - Distributeur"},
    {code : "Producteur - Autres", fr : "Producteur - Autres", en : "Producteur - Autres"},
    {code : "Presse", fr : "Presse", en : "Presse"},
    {code : "Institutionnel", fr : "Institutionnel", en : "Institutionnel"},
    {code : "Institutionnel - Ecole", fr : "Institutionnel - Ecole", en : "Institutionnel - Ecole"},
    {code : "Institutionnel - Consulat / ambassade", fr : "Institutionnel - Consulat / ambassade", en : "Institutionnel - Consulat / ambassade"},
    {code : "Institutionnel - Musée / centre d'art", fr : "Institutionnel - Musée / centre d'art", en : "Institutionnel - Musée / centre d'art"},
    {code : "Institutionnel - Salon / foire", fr : "Institutionnel - Salon / foire", en : "Institutionnel - Salon / foire"},
    {code : "Autres", fr : "Autres", en : "Autres"}
]

const typologiesObjet = [
    {code : "accesoire", fr : "Accessoires", en : "Accessories"},
    {code : "armoire", fr : "Armoires", en : "Cupboards"},
    {code : "assise", fr : "Assises", en : "Seating"},
    {code : "bibliotheque", fr : "Bibliothèques", en : "Bookcases"},
    {code : "buffet", fr : "Buffets", en : "Sideboards"},
    {code : "collection", fr : "Collections", en : "Collections"},
    {code : "commode", fr : "Commodes", en : "Chests of drawers"},
    {code : "console", fr : "Consoles", en : "Consoles"},
    {code : "etagere", fr : "Étagères", en : "Shelves"},
    {code : "tapis", fr : "Tapis", en : "Rugs"},
    {code : "miroir", fr : "Miroirs", en : "Mirrors"},
    {code : "paravent", fr : "Paravents", en : "Screens"},
    {code : "portemanteau", fr : "Porte-manteaux", en : "Coat racks"},
    {code : "table", fr : "Tables", en : "Tables"},
    {code : "luminaire", fr : "Luminaires", en : "Lighting"},
    {code : "autre", fr : "Autres", en : "Others"}
]

const typologiesEspace = [
    {code : "retail", fr : "Retail", en : "Retail"},
    {code : "hotel", fr : "Hôtel", en : "Hotel"},
    {code : "office", fr : "Bureau", en : "Office"},
    {code : "restaurant", fr : "Restaurant / bar", en : "Restaurant / bar"},
    {code : "culturel", fr : "Espace culturel", en : "Cultural space"},
    {code : "privee", fr : "Résidence privée", en : "Private residence"},
    {code : "urbain", fr : "Espace urbain / transport", en : "Urban space / transport"},
    // {code : "scenographie", fr : "Scénographie", en : "Scenography"},
    {code : "installation", fr : "Installation", en : "Installation"},
    {code : "architecture", fr : "Architecture", en : "Architecture"},
    {code : "autre", fr : "Autres", en : "Others"}
]

const positionnements = [
    {code : "Entrée de gamme", fr : "Entrée de gamme", en : "Entry level"},
    {code : "Moyen de gamme", fr : "Moyen de gamme", en : "Mid-range"},
    {code : "Haut de gamme", fr : "Haut de gamme", en : "High-end"},
    {code : "Luxe", fr : "Luxe", en : "Luxury"}
]

const clientèles = [
    {code : "Particuliers", fr : "Particuliers", en : "Individuals"},
    {code : "Professionnels", fr : "Professionnels", en : "Professionals"},
    {code : "France", fr : "France", en : "France"},
    {code : "Europe", fr : "Europe", en : "Europe"},
    {code : "International", fr : "International", en : "International"}
]

const activitésEntreprise = [
    {code : "Donneur d'ordre", fr : "Donneur d'ordre / prescripteur", en : "Client / prescriber"},
    {code : "Créateur - Architecte", fr : "Architecte", en : "Architect"},
    {code : "Créateur - Designer objet", fr : "Designer objet", en : "Object designer"},
    {code : "Créateur - Designer espace", fr : "Architecte d'intérieur", en : "Interior architect"},
    {code : "Créateur - Graphiste", fr : "Graphiste", en : "Graphic designer"},
    {code : "Créateur - Scénographe", fr : "Scénographe", en : "Scenographer"},
    {code : "Créateur - Stratégie de marque", fr : "Créateur stratégie de marque", en : "Brand strategy creator"},
    {code : "Créateur - Stratégie digitale", fr : "Créateur stratégie digitale", en : "Digital strategy creator"},
    {code : "Producteur -  Galerie", fr : "Galeriste", en : "Gallery owner"},
    {code : "Producteur - Equipementier / Matériaux", fr : "Équipementier / matériaux", en : "Equipment supplier / materials"},
    {code : "Producteur - Agenceur", fr : "Agenceur", en : "Fitter"},
    {code : "Producteur - Editeur", fr : "Éditeur", en : "Publisher"},
    {code : "Producteur - Distributeur", fr : "Distributeur", en : "Distributor"},
    {code : "Producteur - Autres", fr : "Autre", en : "Other"},
    {code : "Producteur - Fabricant", fr : "Fabricant", en : "Manufacturer"},
    {code : "Créateur - Artisan d'art", fr : "Artisan d'art", en : "Craftsman"},
]

const savoirFaires = [
    {code : "Textile / Cuir", fr : "Textile / Cuir", en : "Textile / Leather"},
    {code : "Tapis", fr : "Tapis", en : "Rugs"},
    {code : "Céramique & Plâtre", fr : "Céramique & Plâtre", en : "Ceramic & Plaster"},
    {code : "Métaux", fr : "Métaux", en : "Metals"},
    {code : "Pierre / Marbre", fr : "Pierre / Marbre", en : "Stone / Marble"},
    {code : "Verre / Cristal", fr : "Verre / Cristal", en : "Glass / Crystal"},
    {code : "Luminaires", fr : "Luminaires", en : "Lighting"},
    {code : "Autre", fr : "Autre", en : "Other"}
]

const secteurs = [
    {code : "Domestique", fr : "Domestique", en : "Domestic"},
    {code : "Literie", fr : "Literie", en : "Bedding"},
    {code : "Cuisine", fr : "Cuisine", en : "Kitchen"},
    {code : "Salle de bain", fr : "Salle de bain", en : "Bathroom"},
    {code : "Espace de bureau", fr : "Espace de bureau", en : "Office space"},
    {code : "Espace urbain", fr : "Espace urbain", en : "Urban space"},
    {code : "Outdoor", fr : "Outdoor", en : "Outdoor"},
    {code : "Transport", fr : "Transport", en : "Transport"},
    {code : "Espace collectif", fr : "Espace collectif", en : "Collective space"},
]

const langues = [
    {code : "Albanais", fr : "Albanais", en : "Albanian"},
    {code : "Allemand", fr : "Allemand", en : "German"},
    {code : "Anglais", fr : "Anglais", en : "English"},
    {code : "Arabe", fr : "Arabe", en : "Arabic"},
    {code : "Arménien", fr : "Arménien", en : "Armenian"},
    {code : "Basque", fr : "Basque", en : "Basque"},
    {code : "Chinois", fr : "Chinois", en : "Chinese"},
    {code : "Corse", fr : "Corse", en : "Corsican"},
    {code : "Coréen", fr : "Coréen", en : "Korean"},
    {code : "Croate", fr : "Croate", en : "Croatian"},
    {code : "Danois", fr : "Danois", en : "Danish"},
    {code : "Espagnol", fr : "Espagnol", en : "Spanish"},
    {code : "Finnois", fr : "Finnois", en : "Finnish"},
    {code : "Flamand", fr : "Flamand", en : "Flemish"},
    {code : "Français", fr : "Français", en : "French"},
    {code : "Grec", fr : "Grec", en : "Greek"},
    {code : "Hébreu", fr : "Hébreu", en : "Hebrew"},
    {code : "Hindi", fr : "Hindi", en : "Hindi"},
    {code : "Hongrois", fr : "Hongrois", en : "Hungarian"},
    {code : "Indonésien", fr : "Indonésien", en : "Indonesian"},
    {code : "Islandais", fr : "Islandais", en : "Icelandic"},
    {code : "Italien", fr : "Italien", en : "Italian"},
    {code : "Japonais", fr : "Japonais", en : "Japanese"},
    {code : "Kurde", fr : "Kurde", en : "Kurdish"},
    {code : "Laotien", fr : "Laotien", en : "Laotian"},
    {code : "Lingala", fr : "Lingala", en : "Lingala"},
    {code : "Luxembourgeois", fr : "Luxembourgeois", en : "Luxembourgish"},
    {code : "Malgache", fr : "Malgache", en : "Malagasy"},
    {code : "Mandarin", fr : "Mandarin", en : "Mandarin"},
    {code : "Néerlandais", fr : "Néerlandais", en : "Dutch"},
    {code : "Norvégien", fr : "Norvégien", en : "Norwegian"},
    {code : "Polonais", fr : "Polonais", en : "Polish"},
    {code : "Portugais", fr : "Portugais", en : "Portugese"},
    {code : "Roumain", fr : "Roumain", en : "Romanian"},
    {code : "Russe", fr : "Russe", en : "Russian"},
    {code : "Serbe", fr : "Serbe", en : "Serbian"},
    {code : "Slovène", fr : "Slovène", en : "Slovenian"},
    {code : "Suédois", fr : "Suédois", en : "Swedish"},
    {code : "Tchèque", fr : "Tchèque", en : "Czech"},
    {code : "Thaï", fr : "Thaï", en : "Thai"},
    {code : "Turc", fr : "Turc", en : "Turkish"},
    {code : "Ukrainien", fr : "Ukrainien", en : "Ukrainian"}
]

const CountrySelectOptions = () => {
    return (<>
        <option value="France">France</option>
        <option value="Afghanistan">Afghanistan</option>
        <option value="Aland Islands">Åland Islands</option>
        <option value="Albania">Albania</option>
        <option value="Algeria">Algeria</option>
        <option value="American Samoa">American Samoa</option>
        <option value="Andorra">Andorra</option>
        <option value="Angola">Angola</option>
        <option value="Anguilla">Anguilla</option>
        <option value="Antarctica">Antarctica</option>
        <option value="Antigua and Barbuda">Antigua & Barbuda</option>
        <option value="Argentina">Argentina</option>
        <option value="Armenia">Armenia</option>
        <option value="Aruba">Aruba</option>
        <option value="Australia">Australia</option>
        <option value="Austria">Austria</option>
        <option value="Azerbaijan">Azerbaijan</option>
        <option value="Bahamas">Bahamas</option>
        <option value="Bahrain">Bahrain</option>
        <option value="Bangladesh">Bangladesh</option>
        <option value="Barbados">Barbados</option>
        <option value="Belarus">Belarus</option>
        <option value="Belgium">Belgium</option>
        <option value="Belize">Belize</option>
        <option value="Benin">Benin</option>
        <option value="Bermuda">Bermuda</option>
        <option value="Bhutan">Bhutan</option>
        <option value="Bolivia">Bolivia</option>
        <option value="Bonaire, Sint Eustatius and Saba">Caribbean Netherlands</option>
        <option value="Bosnia and Herzegovina">Bosnia & Herzegovina</option>
        <option value="Botswana">Botswana</option>
        <option value="Bouvet Island">Bouvet Island</option>
        <option value="Brazil">Brazil</option>
        <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
        <option value="Brunei Darussalam">Brunei</option>
        <option value="Bulgaria">Bulgaria</option>
        <option value="Burkina Faso">Burkina Faso</option>
        <option value="Burundi">Burundi</option>
        <option value="Cambodia">Cambodia</option>
        <option value="Cameroon">Cameroon</option>
        <option value="Canada">Canada</option>
        <option value="Cape Verde">Cape Verde</option>
        <option value="Cayman Islands">Cayman Islands</option>
        <option value="Central African Republic">Central African Republic</option>
        <option value="Chad">Chad</option>
        <option value="Chile">Chile</option>
        <option value="China">China</option>
        <option value="Christmas Island">Christmas Island</option>
        <option value="Cocos (Keeling) Islands">Cocos (Keeling) Islands</option>
        <option value="Colombia">Colombia</option>
        <option value="Comoros">Comoros</option>
        <option value="Congo">Congo - Brazzaville</option>
        <option value="Congo, Democratic Republic of the Congo">Congo - Kinshasa</option>
        <option value="Cook Islands">Cook Islands</option>
        <option value="Costa Rica">Costa Rica</option>
        <option value="Cote D'Ivoire">Côte d’Ivoire</option>
        <option value="Croatia">Croatia</option>
        <option value="Cuba">Cuba</option>
        <option value="Curacao">Curaçao</option>
        <option value="Cyprus">Cyprus</option>
        <option value="Czech Republic">Czechia</option>
        <option value="Denmark">Denmark</option>
        <option value="Djibouti">Djibouti</option>
        <option value="Dominica">Dominica</option>
        <option value="Dominican Republic">Dominican Republic</option>
        <option value="Ecuador">Ecuador</option>
        <option value="Egypt">Egypt</option>
        <option value="El Salvador">El Salvador</option>
        <option value="Equatorial Guinea">Equatorial Guinea</option>
        <option value="Eritrea">Eritrea</option>
        <option value="Estonia">Estonia</option>
        <option value="Ethiopia">Ethiopia</option>
        <option value="Falkland Islands (Malvinas)">Falkland Islands (Islas Malvinas)</option>
        <option value="Faroe Islands">Faroe Islands</option>
        <option value="Fiji">Fiji</option>
        <option value="Finland">Finland</option>
        <option value="French Guiana">French Guiana</option>
        <option value="French Polynesia">French Polynesia</option>
        <option value="French Southern Territories">French Southern Territories</option>
        <option value="Gabon">Gabon</option>
        <option value="Gambia">Gambia</option>
        <option value="Georgia">Georgia</option>
        <option value="Germany">Germany</option>
        <option value="Ghana">Ghana</option>
        <option value="Gibraltar">Gibraltar</option>
        <option value="Greece">Greece</option>
        <option value="Greenland">Greenland</option>
        <option value="Grenada">Grenada</option>
        <option value="Guadeloupe">Guadeloupe</option>
        <option value="Guam">Guam</option>
        <option value="Guatemala">Guatemala</option>
        <option value="Guernsey">Guernsey</option>
        <option value="Guinea">Guinea</option>
        <option value="Guinea-Bissau">Guinea-Bissau</option>
        <option value="Guyana">Guyana</option>
        <option value="Haiti">Haiti</option>
        <option value="Heard Island and Mcdonald Islands">Heard & McDonald Islands</option>
        <option value="Holy See (Vatican City State)">Vatican City</option>
        <option value="Honduras">Honduras</option>
        <option value="Hong Kong">Hong Kong</option>
        <option value="Hungary">Hungary</option>
        <option value="Iceland">Iceland</option>
        <option value="India">India</option>
        <option value="Indonesia">Indonesia</option>
        <option value="Iran">Iran</option>
        <option value="Iraq">Iraq</option>
        <option value="Ireland">Ireland</option>
        <option value="Isle of Man">Isle of Man</option>
        <option value="Israel">Israel</option>
        <option value="Italy">Italy</option>
        <option value="Jamaica">Jamaica</option>
        <option value="Japan">Japan</option>
        <option value="Jersey">Jersey</option>
        <option value="Jordan">Jordan</option>
        <option value="Kazakhstan">Kazakhstan</option>
        <option value="Kenya">Kenya</option>
        <option value="Kiribati">Kiribati</option>
        <option value="North Korea">North Korea</option>
        <option value="South Korea">South Korea</option>
        <option value="Kosovo">Kosovo</option>
        <option value="Kuwait">Kuwait</option>
        <option value="Kyrgyzstan">Kyrgyzstan</option>
        <option value="Lao People's Democratic Republic">Laos</option>
        <option value="Latvia">Latvia</option>
        <option value="Lebanon">Lebanon</option>
        <option value="Lesotho">Lesotho</option>
        <option value="Liberia">Liberia</option>
        <option value="Libyan Arab Jamahiriya">Libya</option>
        <option value="Liechtenstein">Liechtenstein</option>
        <option value="Lithuania">Lithuania</option>
        <option value="Luxembourg">Luxembourg</option>
        <option value="Macao">Macao</option>
        <option value="Macedonia, the Former Yugoslav Republic of">North Macedonia</option>
        <option value="Madagascar">Madagascar</option>
        <option value="Malawi">Malawi</option>
        <option value="Malaysia">Malaysia</option>
        <option value="Maldives">Maldives</option>
        <option value="Mali">Mali</option>
        <option value="Malta">Malta</option>
        <option value="Marshall Islands">Marshall Islands</option>
        <option value="Martinique">Martinique</option>
        <option value="Mauritania">Mauritania</option>
        <option value="Mauritius">Mauritius</option>
        <option value="Mayotte">Mayotte</option>
        <option value="Mexico">Mexico</option>
        <option value="Micronesia, Federated States of">Micronesia</option>
        <option value="Moldova, Republic of">Moldova</option>
        <option value="Monaco">Monaco</option>
        <option value="Mongolia">Mongolia</option>
        <option value="Montenegro">Montenegro</option>
        <option value="Montserrat">Montserrat</option>
        <option value="Morocco">Morocco</option>
        <option value="Mozambique">Mozambique</option>
        <option value="Myanmar">Myanmar (Burma)</option>
        <option value="Namibia">Namibia</option>
        <option value="Nauru">Nauru</option>
        <option value="Nepal">Nepal</option>
        <option value="Netherlands">Netherlands</option>
        <option value="Netherlands Antilles">Curaçao</option>
        <option value="New Caledonia">New Caledonia</option>
        <option value="New Zealand">New Zealand</option>
        <option value="Nicaragua">Nicaragua</option>
        <option value="Niger">Niger</option>
        <option value="Nigeria">Nigeria</option>
        <option value="Niue">Niue</option>
        <option value="Norfolk Island">Norfolk Island</option>
        <option value="Northern Mariana Islands">Northern Mariana Islands</option>
        <option value="Norway">Norway</option>
        <option value="Oman">Oman</option>
        <option value="Pakistan">Pakistan</option>
        <option value="Palau">Palau</option>
        <option value="Palestinian Territory, Occupied">Palestine</option>
        <option value="Panama">Panama</option>
        <option value="Papua New Guinea">Papua New Guinea</option>
        <option value="Paraguay">Paraguay</option>
        <option value="Peru">Peru</option>
        <option value="Philippines">Philippines</option>
        <option value="Pitcairn">Pitcairn Islands</option>
        <option value="Poland">Poland</option>
        <option value="Portugal">Portugal</option>
        <option value="Puerto Rico">Puerto Rico</option>
        <option value="Qatar">Qatar</option>
        <option value="Reunion">Réunion</option>
        <option value="Romania">Romania</option>
        <option value="Russian Federation">Russia</option>
        <option value="Rwanda">Rwanda</option>
        <option value="Saint Barthelemy">St. Barthélemy</option>
        <option value="Saint Helena">St. Helena</option>
        <option value="Saint Kitts and Nevis">St. Kitts & Nevis</option>
        <option value="Saint Lucia">St. Lucia</option>
        <option value="Saint Martin">St. Martin</option>
        <option value="Saint Pierre and Miquelon">St. Pierre & Miquelon</option>
        <option value="Saint Vincent and the Grenadines">St. Vincent & Grenadines</option>
        <option value="Samoa">Samoa</option>
        <option value="San Marino">San Marino</option>
        <option value="Sao Tome and Principe">São Tomé & Príncipe</option>
        <option value="Saudi Arabia">Saudi Arabia</option>
        <option value="Senegal">Senegal</option>
        <option value="Serbia">Serbia</option>
        <option value="Serbia and Montenegro">Serbia</option>
        <option value="Seychelles">Seychelles</option>
        <option value="Sierra Leone">Sierra Leone</option>
        <option value="Singapore">Singapore</option>
        <option value="Sint Maarten">Sint Maarten</option>
        <option value="Slovakia">Slovakia</option>
        <option value="Slovenia">Slovenia</option>
        <option value="Solomon Islands">Solomon Islands</option>
        <option value="Somalia">Somalia</option>
        <option value="South Africa">South Africa</option>
        <option value="South Georgia and the South Sandwich Islands">South Georgia & South Sandwich Islands</option>
        <option value="South Sudan">South Sudan</option>
        <option value="Spain">Spain</option>
        <option value="Sri Lanka">Sri Lanka</option>
        <option value="Sudan">Sudan</option>
        <option value="Suriname">Suriname</option>
        <option value="Svalbard and Jan Mayen">Svalbard & Jan Mayen</option>
        <option value="Swaziland">Eswatini</option>
        <option value="Sweden">Sweden</option>
        <option value="Switzerland">Switzerland</option>
        <option value="Syrian Arab Republic">Syria</option>
        <option value="Taiwan, Province of China">Taiwan</option>
        <option value="Tajikistan">Tajikistan</option>
        <option value="Tanzania, United Republic of">Tanzania</option>
        <option value="Thailand">Thailand</option>
        <option value="Timor-Leste">Timor-Leste</option>
        <option value="Togo">Togo</option>
        <option value="Tokelau">Tokelau</option>
        <option value="Tonga">Tonga</option>
        <option value="Trinidad and Tobago">Trinidad & Tobago</option>
        <option value="Tunisia">Tunisia</option>
        <option value="Turkey">Turkey</option>
        <option value="Turkmenistan">Turkmenistan</option>
        <option value="Turks and Caicos Islands">Turks & Caicos Islands</option>
        <option value="Tuvalu">Tuvalu</option>
        <option value="Uganda">Uganda</option>
        <option value="Ukraine">Ukraine</option>
        <option value="United Arab Emirates">United Arab Emirates</option>
        <option value="United Kingdom">United Kingdom</option>
        <option value="United States">United States</option>
        <option value="United States Minor Outlying Islands">U.S. Outlying Islands</option>
        <option value="Uruguay">Uruguay</option>
        <option value="Uzbekistan">Uzbekistan</option>
        <option value="Vanuatu">Vanuatu</option>
        <option value="Venezuela">Venezuela</option>
        <option value="Viet Nam">Vietnam</option>
        <option value="Virgin Islands, British">British Virgin Islands</option>
        <option value="Virgin Islands, U.s.">U.S. Virgin Islands</option>
        <option value="Wallis and Futuna">Wallis & Futuna</option>
        <option value="Western Sahara">Western Sahara</option>
        <option value="Yemen">Yemen</option>
        <option value="Zambia">Zambia</option>
        <option value="Zimbabwe">Zimbabwe</option>
    </>)
}

const archiIntListA = (lang) => lang === "fr" ?
[
    {
        label: "Architecture d'intérieur",
        options: [
            { value: "comm", label: " Commerce et retail" },
            { value: "equip", label: "Equipements publics" },
            { value: "hotel_interieur", label: "Hôtels, restaurants" },
            { value: "res_interieur", label: "Résidences privées" },
            { value: "scen_interieur", label: "Scénographie et installation" },
            { value: "transp", label: " Transport" },
        ]
    },
    {
        label: "Architecte",
        options: [
            { value: "dplg", label: "Architecte DPLG" },

        ]
    },
    {
        label: "Donneur d'ordre",
        options: [

            { value: "groupe", label: "Groupe hôtelier / restauration" },
            { value: "res_architecte", label: "Opérateur de co-working/co-living" },
            { value: "promot", label: " Promoteur immobilier" },
            { value: "space", label: "Space planner" },
        ]
    },
] : [
    {
        label: "Architecture d'intérieur",
        options: [
            { value: "comm", label: " Business and retail" },
            { value: "equip", label: "Public facilities" },
            { value: "hotel_interieur", label: "Hotels, restaurants" },
            { value: "res_interieur", label: "Private residences" },
            { value: "scen_interieur", label: "Scenography and installation" },
            { value: "transp", label: " Transport" },
        ]
    },
    {
        label: "Architecture",
        options: [
            { value: "dplg", label: "Licensed architect" },

        ]
    },

    {
        label: "Client, specifier",
        options: [

            { value: "groupe", label: "Hotel/restaurant group" },
            { value: "res_architecte", label: "Co-working/ co-living provider" },
            { value: "promot", label: "Property developer " },
            { value: "space", label: "Space planner" },
        ]
    },

];

const critereListA = (lang) => lang === "fr" ? [
    { value: "agen", label: "Agenceur" },
    { value: "arti", label: "Artisan d'art/ Haute Facture" },
    { value: "edit", label: "Editeur de mobilier" },
    { value: "fabr", label: "Fabricant" },
    { value: "indus", label: "Industriel" },
    { value: "autre", label: "Autre" },
] : [
    { value: "agen", label: "Fitter" },
    { value: "arti", label: "Craftsperson/ High quality craftwork" },
    { value: "edit", label: "Furniture editor" },
    { value: "fabr", label: "Manufacturer" },
    { value: "indus", label: "Industrial" },
    { value: "autre", label: "Other" },
];

const rechercheProcessA = (lang) => lang === "fr" ? [
    {
        label: "Process innovants",
        options: [
            { value: "eco", label: "Matériaux éco-innovants (par exemple: matériau à base de drêche de bière, panneaux MDF fabriqués avec une résine naturelle végétale, matériau acoustique en textile recyclé)" },
            { value: "alt", label: "Techniques alternatives (par exemple : production de soie 3D naturelle) & Nouvelles technologies (par exemple : conception-modélisation 3D, impression 3D avec matériaux naturels ou recyclés)" },
            // { value: "techno", label: "Nouvelles technologies (par exemple : conception/modélisation 3D, impression 3D avec matériaux naturels ou recyclés)" },
            { value: "no", label: "Je ne recherche pas de process innovants" },
        ]
    },
] : [
    {
        label: "Innovative processes",
        options: [
            { value: "eco", label: "Eco-innovative materials (e.g. material made from brewers&#39; grains, MDF panels made from a natural plant-based resin, acoustic fabric made from recycled textiles)" },
            { value: "alt", label: "Alternative techniques (e.g. production of natural 3D silk) & New technologies (e.g. 3D design/modelling, 3D printing with natural or recycled materials, artificial intelligence)" },
            // { value: "techno", label: "New technologies (e.g. 3D design/modelling, 3D printing with natural or recycled materials, artificial intelligence)" },
            { value: "no", label: "I'm not looking for innovative processes" },
        ]
    },
];

const rechercheProductionA = (lang) => lang === "fr" ? [
    {
        label: "Production locale",
        options: [
            { value: "eco", label: "Fabrication en circuit court (par exemple : savoir-faire locaux, traçabilité)" },
            { value: "alt", label: "Artisanat (par exemple : très petites séries ou pièces uniques issues de chutes de matériaux)" },
            { value: "no", label: "Je ne recherche pas de production locale" },
        ]
    },
] : [
    {
        label: "Local production",
        options: [
            { value: "eco", label: "Short production runs (e.g. local know-how, traceability)" },
            { value: "alt", label: "Crafts (e.g. very small production runs or one-off pieces made from off-cuts) " },
            { value: "no", label: "I am not looking for local production" },
        ]
    },
];

const rechercheFlexA = (lang) => lang === "fr" ? [
    {
        label: "Flexibilité d'usage",
        options: [
            { value: "eco", label: "Location & leasing (par exemple location de mobilier et services associés)" },
            { value: "alt", label: "Mobilier multifonctions (par exemple un mobilier évolutif pour enfant)" },
            { value: "no", label: "Je ne recherche pas de flexibilité d'usage" },
        ]
    },
] : [
    {
        label: "Flexibility of use",
        options: [
            { value: "eco", label: "Rental & leasing (e.g. rental of furniture and associated services)" },
            { value: "alt", label: "Multifunctional furniture (e.g. adjustable furniture for children) " },
            { value: "no", label: "I am not looking for flexibility of use" },
        ]
    },
];

const rechercheModelA = (lang) => lang === "fr" ? [
    {
        label: "Nouveaux modèles de l'économie circulaire",
        options: [
            { value: "recy", label: "Recyclage (par exemple : fauteuil réalisé à partir de plastiques et mousses recyclés)" },
            { value: "upcy", label: "Réutilisation / Upcycling (par exemple : bureaux fabriqués à partir d’anciennes portes récupérées)" },
            { value: "reemp", label: "Réemploi (par exemple : récupération de lampes ou de canapés, réemployés pour le même usage)" },
            { value: "rse", label: "Eco-conception, engagements RSE, ESS, labels (par exemple : B Corp™ , EPV ) ou normes spécifiques" },
            { value: "no", label: "Je ne recherche pas de nouveaux modèles de l'économie circulaire" },
        ]
    }
] : [
    {
        label: "New circular economy models",
        options: [
            { value: "recy", label: "Recycling (e.g. armchair made from recycled plastics and foam) " },
            { value: "upcy", label: "Reuse / Upcycling (e.g. desks made from recycled doors)" },
            { value: "reemp", label: "Reuse (e.g. recovered lamps or sofas, reused for the same purpose)" },
            { value: "rse", label: "CSR, EHS commitments, labels (e.g. B Corp™, EPV - Living Heritage Companies) or specific standards" },
            { value: "no", label: "I'm not looking for any new circular economy models" },
        ]
    }
];

const artisanatTypeA = (lang) => lang === "fr" ? [
    {
        label: "Type de savoir-faire",
        options: [
            { value: "bois", label: "Bois" },
            { value: "ceram", label: "Céramique & Plâtre" },
            { value: "lumin", label: "Luminaires" },
            { value: "pierre", label: "Pierre / Marbre" },
            { value: "plastique", label: "Plastique recyclé" },
            { value: "metau", label: "Métaux" },
            { value: "texti", label: "Textile/cuir" },
            { value: "tapis", label: "Tapis" },
            { value: "verre", label: "Verre / Cristal" },
            { value: "autres", label: "Autres" },
        ]
    }
] : [
    {
        label: "Type of skills",
        options: [
            { value: "bois", label: "Wood" },
            { value: "ceram", label: "Ceramics & Plaster" },
            { value: "lumin", label: "Lights" },
            { value: "pierre", label: "Stone/Marble" },
            { value: "plastique", label: "Recycled plastic" },
            { value: "metau", label: "Metals" },
            { value: "texti", label: "Textile/leather" },
            { value: "tapis", label: "Rugs" },
            { value: "verre", label: "Glass/ Crystal" },
            { value: "autres", label: "Other" },
        ]
    }
];

const artisanatScaleA = (lang) => lang === "fr" ? [
    {
        label: "Echelle de production",
        options: [
            { value: "grande", label: "Grande série" },
            { value: "limit", label: "Edition limitée" },
            { value: "custom", label: "Sur-mesure" },
        ]
    }
] : [
    {
        label: "Scale of production",
        options: [
            { value: "grande", label: "Mass production" },
            { value: "limit", label: "Limited edition" },
            { value: "custom", label: "Bespoke" },
        ]
    }
];

const artisanatExportA = (lang) => lang === "fr" ? [
    {
        label: "Projets à l'export",
        options: [
            { value: "Europe", label: "Europe" },
            { value: "Grand export", label: "Grand export" },
            { value: "no export", label: "Je ne recherche pas de projet à l'export" }
        ]
    }
] : [
    {
        label: "Projects for export",
        options: [
            { value: "Europe", label: "Europe" },
            { value: "Grand export", label: "    Large-scale export" },
            { value: "no export", label: "   I am not looking for a project for export" }
        ]
    }
];

const mobilierTypeA = (lang) => [
    {
        label: "Type de mobilier",
        options: [
            { value: "indoor", label: "Indoor" },
            { value: "outdoor", label: "Outdoor" },
            { value: "otro", label: "Autres" },
        ]
    }
];

const mobilierExportA = (lang) => lang === "fr" ? [
    {
        label: "Projets à l'export",
        options: [
            { value: "Europe", label: "Europe" },
            { value: "Grand export", label: "Grand export" },
            { value: "no export", label: "Je ne recherche pas de projet à l'export" }
        ]
    }
] : [
    {
        label: "Projects for export",
        options: [
            { value: "Europe", label: "Europe" },
            { value: "Grand export", label: "Large-scale export" },
            { value: "no export", label: "I am not looking for a project for export" }
        ]
    }
];

const mobilierMaterialA = (lang) => lang === "fr" ? [
    {
        label: "Type de matériaux",
        options: [
            { value: "bois", label: "Bois" },

            { value: "ceram", label: "Céramique & Plâtre" },
            { value: "lumin", label: "Luminaires" },
            { value: "pierre", label: "Pierre / Marbre" },
            { value: "plastique", label: "Plastique recyclé" },

            { value: "metau", label: "Métaux" },
            { value: "texti", label: "Textile/cuir" },
            { value: "tapis", label: "Tapis" },
            { value: "verre", label: "Verre / Cristal" },
            { value: "autres", label: "Autres" },
        ]
    }
] : [
    {
        label: "Type of materials",
        options: [
            { value: "bois", label: "Wood" },

            { value: "ceram", label: "Ceramics & Plaster" },
            { value: "lumin", label: "Lights" },
            { value: "pierre", label: "Stone/Marble" },
            { value: "plastique", label: "Recycled plastic" },

            { value: "metau", label: "Metals" },
            { value: "texti", label: "Textile/leather" },
            { value: "tapis", label: "Rugs" },
            { value: "verre", label: "Glass/ Crystal" },
            { value: "autres", label: "Other" },
        ]
    }
];

const mobilierScaleA = (lang) => lang === "fr" ? [
    {
        label: "Echelle de production",
        options: [
            { value: "grande", label: "Grande série" },
            { value: "limit", label: "Edition limitée" },
            { value: "custom", label: "Sur-mesure" },
        ]
    }
] : [
    {
        label: "Scale of production",
        options: [
            { value: "grande", label: "Mass production" },
            { value: "limit", label: "Limited edition" },
            { value: "custom", label: "Bespoke" },
        ]
    }
];

const SDE2024MultiSelectOptionsA = {
    archiIntListA,
    critereListA,
    rechercheProcessA,
    rechercheProductionA,
    rechercheFlexA,
    rechercheModelA,
    artisanatTypeA,
    artisanatScaleA,
    artisanatExportA,
    mobilierTypeA,
    mobilierExportA,
    mobilierMaterialA,
    mobilierScaleA
}

const archiIntListB = (lang) => lang === "fr" ?
[
    {
        label: "Architecture d'intérieur",
        options: [
            { value: "comm", label: " Commerce et retail" },
            { value: "equip", label: "Equipements publics" },
            { value: "hotel_interieur", label: "Hôtels, restaurants" },
            { value: "res_interieur", label: "Résidences privées" },
            { value: "scen_interieur", label: "Scénographie et installation" },
            { value: "transp", label: " Transport" },
        ]
    },
    {
        label: "Architecte",
        options: [
            { value: "dplg", label: "Architecte DPLG" },

        ]
    },

    {
        label: "Donneur d'ordre",
        options: [

            { value: "groupe", label: "Groupe hôtelier / restauration" },
            { value: "res_architecte", label: "Opérateur de co-working/co-living" },
            { value: "promot", label: " Promoteur immobilier" },
            { value: "space", label: "Space planner" },
        ]
    },

] :
//trads en :



[
    {
        label: "Architecture d'intérieur",
        options: [
            { value: "comm", label: " Business and retail" },
            { value: "equip", label: "Public facilities" },
            { value: "hotel_interieur", label: "Hotels, restaurants" },
            { value: "res_interieur", label: "Private residences" },
            { value: "scen_interieur", label: "Scenography and installation" },
            { value: "transp", label: " Transport" },
        ]
    },
    {
        label: "Architecture",
        options: [
            { value: "dplg", label: "Licensed architect" },

        ]
    },

    {
        label: "Client, specifier",
        options: [

            { value: "groupe", label: "Hotel/restaurant group" },
            { value: "res_architecte", label: "Co-working/ co-living provider" },
            { value: "promot", label: "Property developer " },
            { value: "space", label: "Space planner" },
        ]
    },

];

const rechercheProcessB = (lang) => lang === "fr" ? [
{
    label: "Process innovants",

    options: [
        { value: "eco", label: "Matériaux éco-innovants (par exemple : matériau à base de drêche de bière, panneaux MDF fabriqués avec une résine naturelle végétale, matériau acoustique en textile recyclé)" },
        { value: "alt", label: "Techniques alternatives (par exemple : production de soie 3D naturelle) & Nouvelles technologies (par exemple : conception-modélisation 3D,  impression 3D avec matériaux naturels ou recyclés)" },
        // { value: "techno", label: "Nouvelles technologies (par exemple : conception/modélisation 3D, impression 3D avec matériaux naturels ou recyclés)" },
        { value: "no", label: "Je ne propose pas de process innovants" },


    ]
   
},

] : [
{
    label: "Innovative processes",
    options: [
        { value: "eco", label: "Eco-innovative materials (e.g. material made from brewers&#39; grains, MDF panels made from a natural plant-based resin, acoustic fabric made from recycled textiles)" },
        { value: "alt", label: "Alternative techniques (e.g. production of natural 3D silk) & New technologies (e.g. 3D design/modelling, 3D printing with natural or recycled materials, artificial intelligence)" },
        // { value: "techno", label: "New technologies (e.g. 3D design/modelling, 3D printing with natural or recycled materials, artificial intelligence)" },
        { value: "no", label: "I'm not offering innovative processes" },
    ]
},

];

const rechercheProductionB = (lang) => lang === "fr" ? [
{
    label: "Production locale",
    options: [
        { value: "eco", label: "Fabrication en circuit court (par exemple : savoir-faire locaux, traçabilité)" },
        { value: "alt", label: "Artisanat (par exemple : très petites séries ou pièces uniques issues de chutes de matériaux)" },
        { value: "no", label: "Je ne propose pas de production locale" },
    ]
},

] : [
    {
        label: "Local production",
        options: [
            { value: "eco", label: "Short production runs (e.g. local know-how, traceability)" },
            { value: "alt", label: "Crafts (e.g. very small production runs or one-off pieces made from off-cuts) " },
            { value: "no", label: "I don't offer local production" },
        ]
    },
];

const rechercheFlexB = (lang) => lang === "fr" ? [
{
    label: "Flexibilité d'usage",
    options: [
        { value: "eco", label: "Location & leasing (par exemple location de mobilier et services associés)" },
        { value: "alt", label: "Mobilier multifonctions (par exemple un mobilier évolutif pour enfant)" },
        { value: "no", label: "Je ne propose pas de flexibilité d'usage" },



    ]
},

]
:
[
    {
        label: "Flexibility of use",
        options: [
            { value: "eco", label: "Rental & leasing (e.g. rental of furniture and associated services)" },
            { value: "alt", label: "Multifunctional furniture (e.g. adjustable furniture for children) " },
            { value: "no", label: "I don't offer for flexibility of use" },



        ]
    },

];

const rechercheModelB = (lang) => lang === "fr" ? [
{
    label: "Nouveaux modèles de l'économie circulaire",
    options: [
        { value: "recy", label: "Recyclage (par exemple : fauteuil réalisé à partir de plastiques et mousses recyclés)" },
        { value: "upcy", label: "Réutilisation / Upcycling (par exemple : bureaux fabriqués à partir d’anciennes portes récupérées)" },
        { value: "reemp", label: "Réemploi (par exemple : récupération de lampes ou de canapés, réemployés pour le même usage)" },
        { value: "rse", label: "Eco-conception, engagements RSE, ESS, labels (par exemple : B Corp™ , EPV ) ou normes spécifiques" },
        { value: "no", label: "Je ne propose pas de nouveaux modèles de l'économie circulaire" },


    ]
}

]
:
[
    {
        label: "New circular economy models",
        options: [
            { value: "recy", label: "Recycling (e.g. armchair made from recycled plastics and foam) " },
            { value: "upcy", label: "Reuse / Upcycling (e.g. desks made from recycled doors)     " },
            { value: "reemp", label: "Reuse (e.g. recovered lamps or sofas, reused for the same purpose)         " },
            { value: "rse", label: "CSR, EHS commitments, labels (e.g. B Corp™, EPV - Living Heritage Companies) or specific standards" },
            { value: "no", label: "I don't offer for any new circular economy models" },


        ]
    }

];

const artisanatTypeB = (lang) => lang === "fr" ? [
{
    label: "Type de savoir-faire",
    options: [
        { value: "bois", label: "Bois" },

        { value: "ceram", label: "Céramique & Plâtre" },
        { value: "lumin", label: "Luminaires" },
        { value: "pierre", label: "Pierre / Marbre" },
        { value: "plastique", label: "Plastique recyclé" },

        { value: "metau", label: "Métaux" },
        { value: "texti", label: "Textile/cuir" },
        { value: "tapis", label: "Tapis" },
        { value: "verre", label: "Verre / Cristal" },
        { value: "autres", label: "Autres" },
    ]
}

] :
[
    {
        label: "Type of skills",
        options: [
            { value: "bois", label: "Wood" },

            { value: "ceram", label: "Ceramics & Plaster" },
            { value: "lumin", label: "Lights" },
            { value: "pierre", label: "Stone/Marble" },
            { value: "plastique", label: "Recycled plastic" },

            { value: "metau", label: "Metals" },
            { value: "texti", label: "Textile/leather" },
            { value: "tapis", label: "Rugs" },
            { value: "verre", label: "Glass/ Crystal" },
            { value: "autres", label: "Other" },
        ]
    }

];

const artisanatScaleB = (lang) => lang === "fr" ? [

{
    label: "Echelle de production",
    options: [
        { value: "grande", label: "Grande série" },
        { value: "limit", label: "Edition limitée" },
        { value: "custom", label: "Sur-mesure" },
    ]
}


] :
[

    {
        label: "Scale of production",
        options: [
            { value: "grande", label: "Mass production" },
            { value: "limit", label: "Limited edition" },
            { value: "custom", label: "Bespoke" },
        ]
    }


];

const artisanatExportB = (lang) => lang === "fr" ? [

{
    label: "Projets à l'export",
    options: [
        { value: "Europe", label: "Europe" },
        { value: "Grand export", label: "Grand export" },
        { value: "no export", label: "Je ne propose pas de projet à l'export" }
    ]
}

] :
[

    {
        label: "Projects for export",
        options: [
            { value: "Europe", label: "Europe" },
            { value: "Grand export", label: "    Large-scale export" },
            { value: "no export", label: "   I am not looking for a project for export" }
        ]
    }

];

const mobilierTypeB = (lang) => [
{
    label: "Type de mobilier",
    options: [
        { value: "indoor", label: "Indoor" },
        { value: "outdoor", label: "Outdoor" },
        { value: "otro", label: "Autres" },

    ]
}
];

const mobilierExportB = (lang) => lang === "fr" ? [

{
    label: "Projets à l'export",
    options: [
        { value: "Europe", label: "Europe" },
        { value: "Grand export", label: "Grand export" },
        { value: "no export", label: "Je n'ai pas de projet à l'export" }
    ]
}

] :
[

    {
        label: "Projects for export",
        options: [
            { value: "Europe", label: "Europe" },
            { value: "Grand export", label: "    Large-scale export" },
            { value: "no export", label: "   I don't have a project for export" }
        ]
    }

];

const mobilierMaterialB = (lang) => lang === "fr" ? [
{
    label: "Type de matériaux",
    options: [
        { value: "bois", label: "Bois" },

        { value: "ceram", label: "Céramique & Plâtre" },
        { value: "lumin", label: "Luminaires" },
        { value: "pierre", label: "Pierre / Marbre" },
        { value: "plastique", label: "Plastique recyclé" },

        { value: "metau", label: "Métaux" },
        { value: "texti", label: "Textile/cuir" },
        { value: "tapis", label: "Tapis" },
        { value: "verre", label: "Verre / Cristal" },
        { value: "autres", label: "Autres" },
    ]
}

] :
[
    {
        label: "Type of materials",
        options: [
            { value: "bois", label: "Wood" },

            { value: "ceram", label: "Ceramics & Plaster" },
            { value: "lumin", label: "Lights" },
            { value: "pierre", label: "Stone/Marble" },
            { value: "plastique", label: "Recycled plastic" },

            { value: "metau", label: "Metals" },
            { value: "texti", label: "Textile/leather" },
            { value: "tapis", label: "Rugs" },
            { value: "verre", label: "Glass/ Crystal" },
            { value: "autres", label: "Other" },
        ]
    }

];

const mobilierScaleB = (lang) => lang === "fr" ? [

{
    label: "Echelle de production",
    options: [
        { value: "grande", label: "Grande série" },
        { value: "limit", label: "Edition limitée" },
        { value: "custom", label: "Sur-mesure" },
    ]
}


] :
[

    {
        label: "Scale of production",
        options: [
            { value: "grande", label: "Mass production" },
            { value: "limit", label: "Limited edition" },
            { value: "custom", label: "Bespoke" },
        ]
    }


];

const SDE2024MultiSelectOptionsB = {
    archiIntListB,
    rechercheProcessB,
    rechercheProductionB,
    rechercheFlexB,
    rechercheModelB,
    artisanatTypeB,
    artisanatScaleB,
    artisanatExportB,
    mobilierTypeB,
    mobilierExportB,
    mobilierMaterialB,
    mobilierScaleB
}

const partageCultureFrancaiseFD100 = (lang) => lang === "fr" ? [
    { value: "nationalite", label: "Français de nationalité (établi en France ou à l’étranger)" },
    { value: "etabli", label: "Etabli ou ayant été établi en France pendant plusieurs années" },
    { value: "etudes", label: "Ayant suivi ses études de design en France" },
    { value: "projets", label: "Portant par ses projets l’art de vivre français (projets en France, ou intégrant des savoirs faire français…)" },
] : [
    { value: "nationalite", label: "French by nationality (established in France or abroad)" },
    { value: "etabli", label: "Established or having been established in France for several years" },
    { value: "etudes", label: "Having studied design in France" },
    { value: "projets", label: "Through his projects, embodying the French art of living (projects in France, or integrating French know-how…)" },
];

const typologieObjetFD100 = (lang) => lang === "fr" ? [
    { value: "accesoire", label: "Accessoire" },
    { value: "armoire", label: "Armoire" },
    { value: "assise", label: "Assise" },
    { value: "bibliotheque", label: "Bibliothèque" },
    { value: "buffet", label: "Buffet" },
    { value: "collection", label: "Collection" },
    { value: "commode", label: "Commode" },
    { value: "console", label: "Console" },
    { value: "etagere", label: "Etagère" },
    { value: "tapis", label: "Tapis" },
    { value: "miroir", label: "Miroir" },
    { value: "paravent", label: "Paravent" },
    { value: "portemanteau", label: "Porte-manteau / Patère / Portant" },
    { value: "table", label: "Table" },
    { value: "luminaire", label: "Luminaire" },
    { value: "autre", label: "Autres" },
] : [
    { value: "accesoire", label: "Accessory" },
    { value: "armoire", label: "Wardrobe" },
    { value: "assise", label: "Seating" },
    { value: "bibliotheque", label: "Bookcase" },
    { value: "buffet", label: "Sideboard" },
    { value: "collection", label: "Collection" },
    { value: "commode", label: "Chest of drawers" },
    { value: "console", label: "Console" },
    { value: "etagere", label: "Shelf" },
    { value: "tapis", label: "Rug" },
    { value: "miroir", label: "Mirror" },
    { value: "paravent", label: "Screen" },
    { value: "portemanteau", label: "Coat rack / Hook / Clothes rack" },
    { value: "table", label: "Table" },
    { value: "luminaire", label: "Lighting" },
    { value: "autre", label: "Others" },
];

const typologieAssiseFD100 = (lang) => lang === "fr" ? [
    { value: "banc", label: "Banc" },
    { value: "canape", label: "Canapé" },
    { value: "chaise", label: "Chaise" },
    { value: "fauteuil", label: "Fauteuil" },
    { value: "tabouret", label: "Tabouret / Pouf" },
] : [
    { value: "banc", label: "Bench" },
    { value: "canape", label: "Sofa" },
    { value: "chaise", label: "Chair" },
    { value: "fauteuil", label: "Armchair" },
    { value: "tabouret", label: "Stool / Pouf" },
];

const typologieTableFD100 = (lang) => lang === "fr" ? [
    { value: "appoint", label: "Table d'appoint" },
    { value: "bureau", label: "Bureau" },
    { value: "manger", label: "Table à manger" },
    { value: "basse", label: "Table basse" },
] : [
    { value: "appoint", label: "Side table" },
    { value: "bureau", label: "Desk" },
    { value: "manger", label: "Dining table" },
    { value: "basse", label: "Coffee table" },
];

const typologieLuminaireFD100 = (lang) => lang === "fr" ? [
    { value: "applique", label: "Applique" },
    { value: "lampadaire", label: "Lampadaire" },
    { value: "lampes", label: "Lampes à poser" },
    { value: "suspension", label: "Suspension" },
    { value: "mobilier", label: "Mobilier / Objet lumineux" },
    { value: "autres", label: "Autres" },
] : [
    { value: "applique", label: "Wall light" },
    { value: "lampadaire", label: "Floor lamp" },
    { value: "lampes", label: "Table lamps" },
    { value: "suspension", label: "Pendant light" },
    { value: "mobilier", label: "Furniture / Light object" },
    { value: "autres", label: "Others" },
];

const tyoplogieEspaceFD100 = (lang) => lang === "fr" ? [
    { value: "retail", label: "Retail" },
    { value: "hotel", label: "Hotel" },
    { value: "office", label: "Office" },
    { value: "restaurant", label: "Restaurant / Bar" },
    { value: "culturel", label: "Espace Culturel" },
    { value: "residence", label: "Résidence privée" },
    { value: "urbain", label: "Espace urbain / Transport" },
    { value: "sceno", label: "Scénographie" },
    { value: "install", label: "Installation" },
    { value: "archi", label: "Architecture" },
    { value: "autre", label: "Autres" },
] : [
    { value: "retail", label: "Retail" },
    { value: "hotel", label: "Hotel" },
    { value: "office", label: "Office" },
    { value: "restaurant", label: "Restaurant / Bar" },
    { value: "culturel", label: "Cultural space" },
    { value: "residence", label: "Private Residence" },
    { value: "urbain", label: "Urban space / Transport" },
    { value: "sceno", label: "Scenography" },
    { value: "install", label: "Installation" },
    { value: "archi", label: "Architecture" },
    { value: "autre", label: "Others" },
];

const FD100MultiSelectOptions = {
    partageCultureFrancaiseFD100,
    typologieObjetFD100,
    typologieAssiseFD100,
    typologieTableFD100,
    typologieLuminaireFD100,
    tyoplogieEspaceFD100
}

function valuesToOptions(value, options) {
    //make sure value is an array
    if (!Array.isArray(value)) {
        value = [value];
    }
    const optionsFlattened = []
    for (let i = 0; i < options.length; i++) {
        if (options[i].options) {
            optionsFlattened.push(...options[i].options);
        }
        if (options[i].value) {
            optionsFlattened.push(options[i]);
        }
    }
    return optionsFlattened.filter(opt => value.includes(opt.value));
}

export {
    profilsVIA,
    profilsNonVIA,
    categoriesViaListing,
    typologiesObjet,
    typologiesEspace,
    CountrySelectOptions,
    positionnements,
    clientèles,
    activitésEntreprise,
    savoirFaires,
    secteurs,
    langues,
    SDE2024MultiSelectOptionsA,
    SDE2024MultiSelectOptionsB,
    FD100MultiSelectOptions,
    valuesToOptions
}
